import React, { useMemo } from "react";
import { ReferenceInput, SelectInput } from "react-admin";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import bg from "date-fns/locale/bg";
import { subMonths } from "date-fns";
import { paymentRequests } from "api/paymentApi";

const OnlineSales = ({ handleParamChange }) => {
  const lastMonth = useMemo(() => {
    const value = subMonths(new Date(), 1);

    handleParamChange("month", value.getMonth() + 1);
    handleParamChange("year", value.getFullYear());

    return value;
  }, [handleParamChange]);

  return (
    <>
      <ReferenceInput
        source="eshopId"
        reference={paymentRequests.getEshopsSelect()}
        filter={{ activeOnly: true, parentsOnly: true }}
      >
        <SelectInput
          label="Електронен магазин"
          onChange={e => handleParamChange("eshopId", e.target.value)}
          helperText={false}
        />
      </ReferenceInput>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={bg}
      >
        <DatePicker
          label={"Mесец"}
          views={["year", "month"]}
          openTo="month"
          defaultValue={lastMonth}
          minDate={new Date("2025-03-01")}
          maxDate={lastMonth}
          onChange={val => {
            handleParamChange("month", val.getMonth() + 1);
            handleParamChange("year", val.getFullYear());
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default OnlineSales;
